import React, { Component } from 'react';
import i18n from '../i18n';
import { getLanguageId } from '../lib/Utils';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import UsersActions from '../redux/UsersRedux';
import AuthActions from '../redux/AuthRedux';
import { withStyles } from '@material-ui/styles';
import withWidth from '@material-ui/core/withWidth';
import clsx from 'clsx';
import { Colors, StyledComponents, Metrics } from '../themes';
import cloneDeep from 'lodash/cloneDeep';
import Header from '../components/header/Header';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '../components/common/Table';
import AlertDialog from '../components/common/AlertDialog';
import SnackbarNotification from '../components/common/SnackbarNotification';
import UserDetails from '../components/usersElements/UserDetails';

const { MainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.general,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
  },
  listWidget: {},
  detailsWidget: {
    maxWidth: 975,
  },
});

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertTitle: '',
      alertContentText: '',
      alertConfirmAction: null,
      // users page params
      usersItemsPerPage: 10,
      usersPageNumber: 0,
      usersSearchValue: null,
      usersSortBy: 'name',
      usersSortDirection: 'ASC',
      // users details
      hideDetails: true,
      isNewUser: false,
      userId: null,
      addressId: '',
      firstName: '',
      lastName: '',
      username: '',
      languageId: '',
      phone: '',
      tfa: false, // Two Factor Authentication,
      status: 1,
      userGroupId: '',
      // user Form Errors:
      isUntouched: true,
    };
  }

  componentDidMount() {
    if (this.props.customerId) {
      this.sendGetUsersRequest();
    }
  }

  componentWillUnmount() {
    this.props.resetUsers();
  }

  componentDidUpdate(prevProps) {
    // distributor or customer change
    if (prevProps.customerId !== this.props.customerId) {
      this.props.resetUsers();
      this.resetUserFormFields();
      if (this.props.customerId) {
        this.sendGetUsersRequest();
      }
    }

    if (prevProps.usersIsLoading && !this.props.usersIsLoading) {
      if (this.props.usersSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.usersSuccessMessage,
        });
        if (this.state.isNewUser) {
          this.setState({ isNewUser: false });
        }
      }
      if (this.props.usersErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.usersErrorMessage,
        });
      }
      if (prevProps.createdId !== this.props.createdId) {
        this.setState({ userId: this.props.createdId, addressId: this.props.createdAddressId, isNewUser: false });
      }
    }
    // reset password
    if (prevProps.resetPasswordIsLoading && !this.props.resetPasswordIsLoading) {
      if (this.props.resetPasswordSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.resetPasswordSuccessMessage,
        });
      }
      if (this.props.resetPasswordErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.resetPasswordErrorMessage,
        });
      }
    }
  }

  // users list table methods

  sendGetUsersRequest() {
    const sortBy = this.state.usersSortBy === 'name' ? 'address.lastName' : this.state.usersSortBy;
    const pageParams = {
      items: this.state.usersItemsPerPage,
      page: this.state.usersPageNumber,
      value: this.state.usersSearchValue,
      sortBy,
      sortDirection: this.state.usersSortDirection,
    };
    this.props.getUsers(this.props.customerId, pageParams);
  }

  changeUsersItemsPerPage = (usersItemsPerPage) => {
    this.setState({ usersItemsPerPage, usersPageNumber: 0 }, () => this.sendGetUsersRequest());
  };

  changeUsersPage = (usersPageNumber) => {
    this.setState({ usersPageNumber }, () => this.sendGetUsersRequest());
  };

  handleSearchUser = (usersSearchValue) => {
    this.setState({ usersSearchValue, usersPageNumber: 0 }, () => this.sendGetUsersRequest());
    this.resetUserFormFields();
  };

  handleSortUser = (usersSortBy, usersSortDirection) => {
    this.setState({ usersSortBy, usersSortDirection, usersPageNumber: 0 }, () => this.sendGetUsersRequest());
    this.resetUserFormFields();
  };

  handleSearchUserKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchUser(value);
    }
  };

  selectUser = (user) => {
    this.resetUserFormFields();
    let userId = user.userId ? user.userId : null,
      username = user.username ? user.username : '',
      addressId = user.address && user.address.addressId ? user.address.addressId : '',
      firstName = user.address && user.address.firstName ? user.address.firstName : '',
      lastName = user.address && user.address.lastName ? user.address.lastName : '',
      languageId = user.languageId ? user.languageId : '',
      phone = user.address && user.address.phone ? user.address.phone : '',
      tfa = user.tfa ? user.tfa : false,
      userGroupId = user.userGroup && user.userGroup.value ? user.userGroup.value : '',
      status = user.status ? user.status : '',
      isFormValid = Boolean(username);
    this.setState({
      hideDetails: false,
      isNewUser: false,
      userId,
      addressId,
      firstName,
      lastName,
      username,
      languageId,
      phone,
      tfa,
      status,
      userGroupId,
      isFormValid,
    });
  };

  // user details form methods

  resetUserFormFields = () => {
    this.setState({
      userId: null,
      addressId: '',
      username: '',
      firstName: '',
      lastName: '',
      languageId: getLanguageId(),
      phone: '',
      tfa: false,
      userGroupId: 5,
      status: 1,
      isUntouched: true,
    });
  };

  handleAddUser = () => {
    this.resetUserFormFields();
    this.setState({ hideDetails: false, usersSearchValue: null, isNewUser: true });
  };

  handleChangeFormValues = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleUserDetailsFormKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (!this.state.usersSearchValue) {
        return this.handleSaveUser();
      }
    }
  };

  handleSaveUser = () => {
    const {
      userId,
      username,
      addressId,
      firstName,
      lastName,
      languageId,
      phone,
      tfa,
      userGroupId,
      status,
    } = this.state;
    const userInfos = {
      username,
      address: { firstName, lastName, phone: phone.replace(/\s/g, '') },
      languageId,
      tfa,
      userGroup: userGroupId,
      customerId: this.props.customerId,
      status,
      ...(!this.state.isNewUser && {
        userId,
        address: { addressId, firstName, lastName, phone: phone.replace(/\s/g, '') },
      }),
    };
    const url = window.location.href
      .replace('/users', '')
      .replace('https://', '')
      .replace('http://', '');
    const sortBy = this.state.usersSortBy === 'name' ? 'address.lastName' : this.state.usersSortBy;
    const pageParams = {
      items: this.state.usersItemsPerPage,
      page: this.state.usersPageNumber,
      value: this.state.usersSearchValue,
      sortBy,
      sortDirection: this.state.usersSortDirection,
    };
    this.state.isNewUser
      ? this.props.createUser(userInfos, this.props.customerId, pageParams, url)
      : this.props.editUser(userInfos, this.props.customerId, pageParams);
  };

  openDeleteUserAlert = () => {
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.deleteUserTitle'),
      alertContentText: `${i18n.t('userManager_confirmDeleteUser1')} ${this.state.username}${i18n.t(
        'userManager_confirmDeleteUser2'
      )}`,
      alertConfirmAction: this.deleteUser,
    });
  };

  deleteUser = () => {
    const sortBy = this.state.usersSortBy === 'name' ? 'address.lastName' : this.state.usersSortBy;
    const pageParams = {
      items: this.state.usersItemsPerPage,
      page: this.state.usersPageNumber,
      value: this.state.usersSearchValue,
      sortBy,
      sortDirection: this.state.usersSortDirection,
    };
    this.props.deleteUser(this.state.username, this.props.customerId, pageParams);
    this.resetUserFormFields();
    this.setState({ isAlertDialogOpen: false, hideDetails: true });
  };

  render() {
    const { t, classes, width } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const usersData = cloneDeep(this.props.users); //this is necessary for table to work
    const flattenedUsersData = usersData
      ? usersData.map((user) => ({
          ...user,
          name: `${user.address.lastName} ${user.address.firstName}`,
        }))
      : null;

    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={this.state.alertTitle}
          contentText={this.state.alertContentText}
          cancelButtonText={t('Global_cancel')}
          confirmButtonText={t('Global_delete')}
          onConfirm={this.state.alertConfirmAction}
        />
        <SnackbarNotification
          variant={this.state.snackbarVariant}
          open={this.state.isSnackbarNotificationOpen}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.listWidget)}>
              <Table
                data={flattenedUsersData}
                noDataText={t('userManager_noUser')}
                handleClick={(value) => this.selectUser(value)}
                columns={[
                  { title: t('userManager_searchUsers_col1'), field: 'name', id: 'name' },
                  { title: t('userManager_searchUsers_col2'), field: 'username', id: 'username' },
                ]}
                firstName={this.state.firstName}
                lastName={this.state.lastName}
                username={this.state.username}
                activeRowValue={this.state.userId}
                activeRowField={'userId'}
                handleSearch={this.handleSearchUser}
                sortBy={this.state.usersSortBy}
                sortDirection={this.state.usersSortDirection}
                handleSort={this.handleSortUser}
                searchPlaceholder={t('userManager_searchUsers')}
                itemsPerPage={this.state.usersItemsPerPage}
                changeItemsPerPage={this.changeUsersItemsPerPage}
                totalElements={this.props.usersTotalElements}
                page={this.state.usersPageNumber}
                changePage={this.changeUsersPage}
                onKeyPress={this.handleSearchUserKeyPress}
                // rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.usersItemsPerPage}
                onSelect={this.changeUsersItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.detailsWidget)}>
              <UserDetails
                // buttons
                add1ButtonText={t('userManager_addNewUser')}
                onDeleteButtonClick={this.openDeleteUserAlert}
                onAdd1ButtonClick={this.handleAddUser}
                onSaveButtonClick={this.handleSaveUser}
                isDeleteButtonDisabled={!this.state.userId || this.state.isNewUser}
                // details form
                onKeyPressFormSubmit={this.handleUserDetailsFormKeyPress}
                onChange={this.handleChangeFormValues}
                hideDetails={this.state.hideDetails}
                userId={this.state.userId}
                username={this.state.username}
                firstName={this.state.firstName}
                lastName={this.state.lastName}
                street={this.state.street}
                languageId={this.state.languageId}
                onSelectLanguage={(languageId) => this.setState({ languageId })}
                phone={this.state.phone}
                onChangePhone={(phone) => this.setState({ phone })}
                tfa={this.state.tfa}
                onChangeTfa={(event) => this.setState({ tfa: event.target.checked })}
                userGroupId={this.state.userGroupId}
                onSelectUserGroup={(userGroupId) => this.setState({ userGroupId })}
                // form validation
                isUntouched={this.state.isUntouched}
                setUntouched={(value) => this.setState({ isUntouched: value })}
                // reset passwordButton
                resetPasswordButtonText={t('auth.resetPasswordButton')}
                resetPasswordButtonClick={() =>
                  this.props.sendResetPasswordEmail(
                    this.state.username,
                    window.location.href
                      .replace('/users', '')
                      .replace('https://', '')
                      .replace('http://', '')
                  )
                }
                isNewUser={this.state.isNewUser}
                // details table
                noDetailsTable
              />
            </Paper>
          </Grid>
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.auth.customerId,
    distributorId: state.auth.distributorId,
    //users
    users: state.users.users,
    usersTotalElements: state.users.totalElements,
    createdId: state.users.createdId,
    createdAddressId: state.users.createdAddressId,
    usersIsLoading: state.users.isLoading,
    usersSuccessMessage: state.users.successMessage,
    usersErrorMessage: state.users.errorMessage,
    // reset password
    resetPasswordIsLoading: state.auth.isLoading,
    resetPasswordSuccessMessage: state.auth.successMessage,
    resetPasswordErrorMessage: state.auth.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // users
  getUsers: (customerId, pageParams) => dispatch(UsersActions.getUsersRequest(customerId, pageParams)),
  createUser: (userInfos, customerId, pageParams, url) =>
    dispatch(UsersActions.createUserRequest(userInfos, customerId, pageParams, url)),
  editUser: (userInfos, customerId, pageParams) =>
    dispatch(UsersActions.editUserRequest(userInfos, customerId, pageParams)),
  deleteUser: (username, customerId, pageParams) =>
    dispatch(UsersActions.deleteUserRequest(username, customerId, pageParams)),
  resetUsers: () => dispatch(UsersActions.resetUsers()),
  // reset password
  sendResetPasswordEmail: (username, url) => dispatch(AuthActions.sendResetPasswordEmailRequest(username, url)),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
)(Users);
